
import Vue from 'vue';
import BaseSlider from '@/components/base/BaseSlider.vue';
import RunnitDynamicFieldLabelRow from '@/views/Runnits/RunnitSettings/RunnitDynamicFieldLabelRow.vue';
import { RunnitDynamicFieldMixin } from '@/views/Runnits/RunnitSettings/mixins/RunnitDynamicFieldMixin';
import { getLogicOnFieldsFromField } from '@run-diffusion/shared';
import _isNil from 'lodash/isNil';
import { findClosestSliderValue } from '@/utils/closestOptionUtils';
import { mapActions } from 'vuex';
import { SNACKBAR_STATUS } from '@/constants/constants';

export default Vue.extend({
	name: 'StepsSlider',
	mixins: [
		RunnitDynamicFieldMixin,
	],
	props: {
		field: { type: Object, required: true },
		value: { type: Number, default: null },
		adminOnly: { type: Boolean, default: false },
		inputValues: { type: Object, required: true },
	},
	data () {
		return {};
	},
	computed: {
		logicOnFields () {
			return getLogicOnFieldsFromField(this.field, this.inputValues);
		},
		autoSetValue () {
			return this.logicOnFields.autoSetValue;
		},
		autoSetError () {
			return this.logicOnFields.autoSetError;
		},
	},
	watch: {
		autoSetValue: {
			handler (newValue: any, oldValue: any) {
				// If autoSet value changes, update the field value
				if (!_isNil(newValue) && newValue !== oldValue) {
					this.onFieldInput(newValue);
				}
			},
			immediate: true,
		},
		autoSetError: {
			handler (newVal: string, oldVal: string) {
				if (newVal && newVal !== oldVal) {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.ERROR,
						message: newVal,
						show: true,
					});
				}
			},
			immediate: true,
		},
	},
	methods: {
		_isNil,
		...mapActions([
			'updateSnackbar',
		]),
		onFieldInput (val: any) {
			let valueToTest = null;
			// If field has autoSet value and editing is not allowed, use autoSet value
			if (_isNil(this.logicOnFields.autoSetValue) || this.logicOnFields.autoSetAllowEdit) {
				// Use the user's input value (either manual input or autoSet with allowEdit)
				valueToTest = val;
			} else {
				valueToTest = this.logicOnFields.autoSetValue;
			}
			// Find the closest valid value based on field constraints
			const closestValue = findClosestSliderValue(
				valueToTest,
				_isNil(this.field.display.min) ? 1 : this.field.display.min,
				this.field.display.max || 30,
				this.field.display.step || 1
			);
			this.$emit('input', closestValue);
		},
	},
	components: {
		BaseSlider,
		RunnitDynamicFieldLabelRow,
	},
});
